import { useSecretaryPreferences } from '../../hooks/useSecretaryPreferences';
import SecretaryAvatar from './SecretaryAvatar';

/** 主秘书会话的实时身份标识；保存后同步名称和头像，账号切换时立即回到公共默认值。 */
export default function SecretaryIdentity() {
  const { draft } = useSecretaryPreferences(true);
  const profile = draft?.relationship;
  return <span className="flex min-w-0 items-center gap-2" title={profile?.assistantIntroduction}>
    <SecretaryAvatar preset={profile?.assistantAvatarPreset} className="h-7 w-7" />
    <span className="max-w-32 truncate text-sm font-medium">{profile?.assistantDisplayName || 'BoMate'}</span>
  </span>;
}
